module.exports = __webpack_public_path__ + "static/media/temperature-high.32fa4f2a.svg";